import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/rolePageHeader.css';

const PolePageHeader = ({ setOpenAddPole, hasPoleCreatePermission }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const handleAddPole = useCallback(() => {
        setOpenAddPole(true);
    }, [setOpenAddPole]);

    return (
        <Box className='role_page_header_main_container'>
            <Box className='role_page_header_title_box'>
                <Typography className='role_page_header_page_title'>{t("Pôles")}</Typography>
            </Box>
            {isDesktop && hasPoleCreatePermission &&
                <Box className='role_page_header_action_box' onClick={handleAddPole}>
                    <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='role_page_header_action_title'>{t("addPoleDialogeTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='role_page_header_action_box'>
                    {hasPoleCreatePermission && <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddPole} />}
                </Box>
            }
        </Box>
    );
};

export default React.memo(PolePageHeader);